/*
 * We sure hope this is overkill, but some providers seem to be unusually fussy about
 * how we present their cards. Let’s hope this list stays small.
 */

const CARD_ID_EXCEPTIONS = Object.freeze({
    CapitalOneGuaranteed: [
        'capital-one-guaranteed-mastercard',
        'carte-mastercard-a-approbation-garantie-de-capital-one',
    ],
});

export default CARD_ID_EXCEPTIONS;
